import * as React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore from 'swiper'

import 'swiper/css'

const Slider = ({ items }) => {
    const [activeIndex, setActiveIndex] = React.useState(0)
    const swiperRef = React.useRef(null)

    return (
      <div className="relative max-w-4xl mx-auto">
          <div className="relative h-[450px] md:h-[350px]">
              <Swiper
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                slidesPerView={1}
                allowTouchMove
              >
                  {items.map((item, index) => {
                      const isActive = index === activeIndex
                      const isBefore = index < activeIndex

                      return (
                        <SwiperSlide key={index}>
                            <div
                              className={`
            flex flex-col items-center text-center
            transition-opacity duration-700 ease-in-out
            px-4 md:px-12
            ${index === activeIndex ? 'opacity-100' : 'opacity-0'}
        `}
                            >
                                {/* Avatar */}
                                <div className="mb-8 relative group">
                                    <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-[#8D6E63]/20 p-1 mx-auto transition-all group-hover:border-[#8D6E63]/50">
                                        {item.image && (
                                          <img
                                            src={item.image}
                                            alt={item.name}
                                            className="w-full h-full object-cover rounded-full"
                                          />
                                        )}
                                    </div>
                                </div>

                                {/* Quote */}
                                <div className="relative">
            <span className="absolute -top-6 -left-4 text-7xl font-serif text-[#8D6E63]/10 pointer-events-none">
                “
            </span>
                                    <blockquote className="text-xl md:text-2xl font-serif italic text-[#3E2723] mb-8 leading-relaxed max-w-2xl mx-auto">
                                        {item.text}
                                    </blockquote>
                                    <span className="absolute -bottom-12 -right-4 text-7xl font-serif text-[#8D6E63]/10 pointer-events-none">
                ”
            </span>
                                </div>

                                {/* Name */}
                                <div className="mt-4">
                                    <h4 className="font-bold text-[#3E2723] tracking-[0.2em] uppercase text-sm mb-1">
                                        {item.name}
                                    </h4>
                                    {item.role && (
                                      <p className="text-[10px] text-[#8D6E63] font-bold uppercase tracking-[0.3em] opacity-80">
                                          {item.role}
                                      </p>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>

                      )
                  })}
              </Swiper>
          </div>

          {/* Controls */}
          <div className="flex justify-center items-center space-x-12 mt-4 relative z-10">
              {/* Prev */}
              <button
                onClick={() => swiperRef.current.slidePrev()}
                className="group flex items-center space-x-2 text-[#3E2723] hover:text-[#8D6E63] transition-colors"
                aria-label="Previous review"
              >
                  <div className="w-12 h-12 rounded-full border border-[#E7E0D3] flex items-center justify-center transition-all group-hover:bg-[#3E2723] group-hover:border-[#3E2723] group-hover:text-[#FDFBF7]">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                      </svg>
                  </div>
              </button>

              {/* Bullets */}
              <div className="flex space-x-3">
                  {items.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => swiperRef.current.slideTo(i)}
                      className={`
                                h-1.5 rounded-full transition-all duration-500
                                ${
                        i === activeIndex
                          ? 'bg-[#8D6E63] w-12'
                          : 'bg-[#E7E0D3] w-3 hover:bg-[#8D6E63]/40'
                      }
                            `}
                    />
                  ))}
              </div>

              {/* Next */}
              <button
                onClick={() => swiperRef.current.slideNext()}
                className="group flex items-center space-x-2 text-[#3E2723] hover:text-[#8D6E63] transition-colors"
                aria-label="Next review"
              >
                  <div className="w-12 h-12 rounded-full border border-[#E7E0D3] flex items-center justify-center transition-all group-hover:bg-[#3E2723] group-hover:border-[#3E2723] group-hover:text-[#FDFBF7]">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                  </div>
              </button>
          </div>
      </div>
    )
}

export default Slider
